module.exports = __webpack_public_path__ + "img/coinbrit.dcdadcf7.png";